import "./shared/i18n";

import reportWebVitals from "./reportWebVitals";

import App from "./App";
import ModellingProvider from "./ModellingProvider";
import React from "react";
import ReactDOM from "react-dom/client";
import { BrowserRouter } from "react-router-dom";

const root = ReactDOM.createRoot(document.getElementById("root") as HTMLElement);
root.render(
  <React.StrictMode>
    <ModellingProvider>
      {" "}
      <BrowserRouter>
        <App />
      </BrowserRouter>
    </ModellingProvider>
  </React.StrictMode>,
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
